import styled, { css } from 'styled-components';
import { SectionHeading, SectionWrapper } from '../atoms';
import { SecureCoursesLink } from './CoursesLink';
import type { TCourse, TSubCourse } from '../../common/types/Course';
import { FormattedCurrency } from '../../common/utils/formatters';

type TSubCourses = {
  subCourses: TSubCourse[];
  courseDetails: TCourse;
};

const SubCoursesContainer = styled((props) => <SectionWrapper {...props} />)`
  padding-bottom: 40px;
  margin-top: 0;
`;

const SubCoursesWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  max-height: 460px;
  overflow-y: auto;
  padding: 30px 30px 0;
`;

const SubCoursesTitle = styled((props) => <SectionHeading {...props} />)`
  margin: 30px 30px 0;
`;

const SubCourse = styled.div(
  ({ theme }) => css`
    display: grid;
    gap: 15px;
    grid-template-columns: auto 5.5rem;
    align-items: center;
    border: 1px solid ${theme.colors.warmGrey};
    padding: 16px;
    height: 100%;

    @media (hover: hover) {
      &:hover {
        background-color: ${theme.colors.lightWhiteSmoke};
      }
    }

    @media (max-width: ${theme.breakpoints.max.xs}) {
      grid-template-columns: auto 6rem;
    }
  `
);

const SubCourseCost = styled.span(
  ({ theme }) => css`
    font-size: ${theme.fonts.sizes.h6};
    color: ${theme.colors.darkGrey};
    background-color: ${theme.colors.warmGrey};
    border-radius: 0 20px 20px 0;
    padding: 2px 8px 2px 4px;
    margin-left: 5px;
  `
);

const SubCourseName = styled.h5`
  margin-bottom: 0;
`;

const SubCoursesList = ({ subCourses, courseDetails }: TSubCourses) => {
  const activeSubCourses = subCourses.filter(
    (subCourse) => subCourse.status === 'ACTIVE'
  );
  return (
    <SubCoursesContainer>
      <SubCoursesTitle as="h3">Sub Courses</SubCoursesTitle>
      <SubCoursesWrapper>
        {activeSubCourses.length === 0 && <p>No active sub courses</p>}
        {activeSubCourses.length > 0 &&
          activeSubCourses.map(({ id, name, cost }) => (
            <SubCourse key={id}>
              <SubCourseName>
                {name}
                {cost && (
                  <SubCourseCost>
                    <FormattedCurrency amount={cost} noDecimals />
                  </SubCourseCost>
                )}
              </SubCourseName>
              <SecureCoursesLink
                courseDetails={courseDetails}
                subCourseId={id}
                size="30px"
              />
            </SubCourse>
          ))}
      </SubCoursesWrapper>
    </SubCoursesContainer>
  );
};

export { SubCoursesList };
